var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-subheader',{staticClass:"text-uppercase grey--text grey lighten-5",class:_vm.disabled ? 'text--lighten-1' : 'text--darken-1'},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }